<template>
  <div>
    <v-autocomplete
      v-model="expenseCategoryID"
      :items="getExpensesCategories"
      @change="emitExpenseCategoryID()"
      item-text="name"
      item-value="id"
      dense
      label="Select Expense Category"
    ></v-autocomplete>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getExpensesCategories() {
      return this.$store.getters.getExpensesCategories;
    }
  },

  mounted() {
    axios
      .getData("/auth/get-all-expenses-categories", this.getAccessToken)
      .then(expenseCategories => {
        this.$store.commit("setExpensesCategories", expenseCategories);
      });
  },
  data: () => ({
    expenseCategoryID: null
  }),
  methods: {
    emitExpenseCategoryID() {
      this.$emit("expense-category-selected", this.expenseCategoryID);
    }
  }
};
</script>

<style>
</style>